import { ValidationError } from "sequelize"
import { MtGroup, MtGroupCreate, MtGroupSave } from "server/models"
import { OrderType } from "client/utils"
import {
    GET, POST, DELETE, sort, search, validate,
} from "client/store/utils"
import { LangType, GroupValidation } from "client/store"
import { GroupList, GroupFilters } from "./types"


export const LoadAllGroups = () => (
    GET("/mtGroup/all")
    .then((groups: MtGroup[]) => {
        const groupList: GroupList = {}
        groups.forEach((group) => {
            groupList[group.id] = group
        })
        return groupList
    })
)

export const LoadAccountGroups = (accountId: number) => (
    GET(`/mtGroup/accountId/${accountId}`)
    .then((groups: MtGroup[]) => {
        const groupList: GroupList = {}
        groups.forEach((group) => {
            groupList[group.id] = group
        })
        return groupList
    })
)

export const LoadGroupById = (
    groupId: number,
    accountId: number,
) => (
    GET(`/mtGroup/id/${groupId}/accountId/${accountId}`)
    .then((group: MtGroup) => group)
)

export const SaveGroup = (
    id: number,
    group: MtGroupCreate,
    lang: LangType,
) => {
    const data: MtGroupSave = {
        id,
        group,
    }
    return POST(
        "/mtGroup/save",
        JSON.stringify(data),
    ).then((res) => {
        const newGroup = res as MtGroup
        const error = res as ValidationError
        return {
            newGroupId: newGroup.id || null,
            validation: <GroupValidation>validate(error, lang),
        }
    })
}

export const DeleteGroup = (groupId: number, accountId: number) => (
    DELETE(`/mtGroup/delete/${groupId}/${accountId}`)
    .then((removedRows: number) => removedRows)
)

export const SortGroups = (
    groups: MtGroup[],
    sortColumn: keyof MtGroup,
    sortOrder: OrderType,
    filters: GroupFilters,
) => {
    const groupsFiltered = groups.filter((group) => {
        let showRow = true
        if (filters.search) showRow = search(filters.search, group)
        return showRow
    })
    groupsFiltered.sort((a, b) => sort(a, b, sortColumn, sortOrder))

    const groupIds: number[] = []
    groupsFiltered.forEach((group) => groupIds.push(group.id))

    return groupIds
}
